export const customNumberFormat = (value) =>
  new Intl.NumberFormat().format(value)